// extracted by mini-css-extract-plugin
export default {"ecom-header":"DDtweV","ecomHeader":"DDtweV"};